import { contactService } from "../../services/contact";
import { alertActions } from "./alert-actions";
import { adminConstants } from "../constant/admin-constant";

export const contactActions = {
    storeContact,
    getContactsPagination,
    getContactItem,
    editCustomerContact,
    deleteContact,
    getCustomerContact
};

function getCustomerContact(model_id, model) {
    return dispatch => {
        return contactService.getContactsPagination(model_id, model, '',
            1,
            '',
            '',
            '',
            'false').then( //getCustomerAllContacts
                list => {
                    dispatch({
                        type: adminConstants.GET_LOGGED_IN_CUSTOMER_CONTACTS,
                        payload: list.result
                    });
                },
                error => {
                    dispatch(alertActions.error(error));
                }
            );
    };
}

function deleteContact(list_id) {
    return dispatch => {
        return contactService.deleteContact(list_id).then(
            response => {
                //dispatch({ type: adminConstants.DELETE_ADDRESS_ITEM_SUCCESS, payload: response });
                dispatch(alertActions.success(response.message));
            },
            error => {
                //dispatch({ type: adminConstants.DELETE_ADDRESS_ITEM_FAILURE, payload: error });
                dispatch(alertActions.error(error));
            }
        );
    };
}

function getContactItem(id) {
    return dispatch => {
        return contactService.getContactItem(id).then(
            res => {
                dispatch({
                    type: adminConstants.GET_CONTACT_SUCCESS,
                    payload: res
                });
            },
            error => {
                dispatch({
                    type: adminConstants.GET_CONTACT_FAILURE,
                    payload: error
                });
                dispatch(alertActions.error(error));
            }
        );
    };
}

function getContactsPagination(
    id,
    model,
    filter,
    page,
    sort,
    pageSize,
    component_name,
    pagination
) {
    return dispatch => {
        contactService
            .getContactsPagination(
                id,
                model,
                filter,
                page,
                sort,
                pageSize,
                component_name,
                pagination
            )
            .then(
                response => {
                    dispatch({
                        type: adminConstants.PAGINATION_CUST_CONTACTS_SUCCESS,
                        payload: response.result.contacts
                    });
                },
                error => {
                    dispatch({
                        type: adminConstants.PAGINATION_CUST_CONTACTS_FAILURE,
                        payload: error
                    });
                }
            );
    };
}

function storeContact(data) {
    return dispatch => {
        return contactService.saveCustomerContact(data).then(
            response => {
                dispatch({
                    type: adminConstants.STORE_CUSTMER_ADDRESS,
                    payload: response
                });
                dispatch(alertActions.success(response.message));
                return data;
            },
            error => {
                //dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function editCustomerContact(data, id) {
    return dispatch => {
        return contactService.editCustomerContact(data, id).then(
            response => {
                dispatch({
                    type: adminConstants.STORE_CUSTMER_ADDRESS,
                    payload: response
                });
                dispatch(alertActions.success(response.message));
                return data;
            },
            error => {
                //dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/contact-action.jsx